import type React from 'react';

import type { MultiLang } from '../../../../config';
import Description from './Description';

interface Props {
    lang: MultiLang;
    readme: string;
}

const Readme: React.FC<Props> = (props) => {
    const { lang, readme } = props;
    return <Description lang={lang} description={readme} className="readme" />;
};

export default Readme;
